import React from 'react'
import NumberFormat from 'react-number-format'

export type MaskedUsernameFormatProps = {
  name: string,
  mask?: string,
  formatted?: boolean,
  onChange: (event: { target: { name: string, value: string } }) => void
}

export const PasswordFormat = React.forwardRef<HTMLDivElement, MaskedUsernameFormatProps>((props, ref) => {
  const { ...other } = props

  return (
    <NumberFormat
      {...other}
      maxLength={6}
      getInputRef={ref}
    />
  )
})
